export enum SOCKET_CLIENT {
  SEND_MESSAGE = "send-message",
  RECIEVE_MESSAGE = "recieve-message",
  SEND_CHAT_NOTIFICATION = "send-chat-notification",
  READ_CHAT_NOTIFICATION = "read-chat-notification",
  RECIEVE_CHAT_NOTIFICATION = "recieve-chat-notification",
  TIMERS_UPDATED = "timers-updated",
  RECIEVE_TIMERS = "recieve-timers",
  TRADE = "trade",
  RECIEVE_MY_TRADES = "recieve-my-trades",
}
